'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/node_modules/react-animated-css/node_modules/react/react.js
// module id = 441
// module chunks = 0 1